import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";

export default function ThirdApartament() {
  const [isHovered, setIsHovered] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();
  const imageRef = useRef(null);

  const customUrl1 = "1-mirror"; // First URL (image)
  const customUrl2 = "1"; // Floor number
  const customUrl3 = "9"; // Floor number
  const vrPath = "vr-1-3"; // Dynamic VR directory

  // Detect mobile devices
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  // Close hover effect when clicking outside (only on mobile)
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (imageRef.current && !imageRef.current.contains(event.target)) {
        setIsHovered(false);
        setIsClicked(false);
      }
    };

    if (isMobile && isClicked) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }

    return () => document.removeEventListener("click", handleClickOutside);
  }, [isMobile, isClicked]);

  const handleClick = () => {
    if (isMobile) {
      if (!isClicked) {
        setIsClicked(true);
        setIsHovered(true);
      } else {
        navigate("/navigate-floor", { state: { customUrl1, customUrl2, vrPath, customUrl3 } });
      }
    } else {
      navigate("/navigate-floor", { state: { customUrl1, customUrl2, vrPath, customUrl3 } });
    }
  };

  return (
    <img 
      ref={imageRef}
      className={`absolute w-[9.5vw] left-[31.9vw] top-[19.85vw] cursor-pointer transition-opacity duration-100 ${isHovered ? 'opacity-100' : 'opacity-0'}`}
      src="/images/click/clickable-images/Floors/Direct-floors/clickable-floors/NinethFloor/ThirdApartament-Green.png"
      alt="Third Apartament"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleClick}
    />
  );
}
